import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    close: 'Exit',
    description: 'Follow the progress of your application.',
    inProgress: 'In progress',
    steps: {
      check: {
        description:
          'We check your identity and the conformity of your information. This takes an average of 4 business days.',
        link: 'What checks are made?\nCan it exceed 4 business days?',
        title: 'We check your application',
      },
      getMyKbis: {
        description: 'INSEE sends your SIRET number in 2 weeks on average.',
        link: 'How to get my SIRET?',
        title: 'You receive your SIRET number',
      },
      info: {
        description:
          'All you have to do is answer a series of questions. This takes about 3 minutes.',
        title: 'File your application',
      },
      uploadDocuments: {
        description:
          'We need you to sign and upload a few documents for the State. This takes about 5 minutes.',
        link: 'Why these documents are required?',
        title: 'Upload legal documents',
      },
      useYourAccount: {
        description: {
          biker: 'You can start using your Shine account!',
          nonBiker:
            'You can already legally start working at this point, and start using your Shine account!',
        },
        title: 'We send your file to the State',
      },
    },
    title: 'Create your micro-entreprise with Shine',
  },
  fr: {
    close: 'Fermer',
    description: 'Suivez l’avancement de votre dossier.',
    inProgress: 'En cours',
    steps: {
      check: {
        description:
          'Nous vérifions votre identité et la conformité de vos informations. Cela prend en moyenne 4 jours ouvrés.',
        link: 'Qu’est-ce qui est vérifié\u00A0?\nLe délai de 4 jours ouvrés est-il garanti\u00A0?',
        title: 'Nous vérifions votre dossier',
      },
      getMyKbis: {
        description:
          'L’INSEE envoie votre numéro de SIRET sous 2 semaines en moyenne.',
        link: 'Comment recevoir mon SIRET\u00A0?',
        title: 'Vous recevez votre SIRET',
      },
      info: {
        description:
          'Il vous suffit de répondre à quelques questions. Vous en aurez pour 3 minutes environ.',
        title: 'Renseignez vos informations',
      },
      uploadDocuments: {
        description:
          'Vous devrez signer et nous transmettre quelques documents pour l’administration. Cela vous prendra environ 5 minutes.',
        link: 'Pourquoi me demandez-vous ces documents\u00A0?',
        title: 'Ajoutez vos documents légaux',
      },
      useYourAccount: {
        description: {
          biker:
            'Vous pouvez commencer à utiliser votre compte pro Shine à cette étape\u00A0!',
          nonBiker:
            'Vous pouvez déjà commencer à travailler et utiliser votre compte pro\u00A0!',
        },
        title: 'Nous envoyons votre dossier à l’administration',
      },
    },
    title: 'Créez votre micro-entreprise avec Shine',
  },
} as const);

export default locales;
